import React, { lazy, Suspense, useMemo } from 'react';
import { useHasAccess } from 'cp-client-auth!sofe';
import { CpLoader } from 'canopy-styleguide!sofe';
import { BaseNav } from './base-nav.component';
import { useNav } from '../../nav.context';
import { parseClientIdInHash } from '../primary-navbar.helper';

const TimeCardList = lazy(() =>
  SystemJS.import('billing-ui!sofe').then(billingUI =>
    billingUI.getTimeCardList().then(timeCardList => ({ default: timeCardList }))
  )
);

export const TimeNav = () => {
  const nav = useNav();
  const allowWipReport = useHasAccess('billing_wip_report');
  const allowProductivityDashboard = useHasAccess('time_productivity_dashboard');
  const userHasTasksOrNotices = useHasAccess(['tasks_generic', 'tasks_notices']);

  const navLinks = useMemo(() => {
    return [
      { label: 'Time Entries', url: 'time', enabled: true },
      {
        label: 'WIP Report',
        url: 'time/wip',
        enabled: allowWipReport,
      },
      { label: 'Productivity', url: 'time/productivity', enabled: allowProductivityDashboard && userHasTasksOrNotices },
    ];
  }, [nav.user, allowProductivityDashboard, userHasTasksOrNotices]);

  const contactId = useMemo(() => {
    return parseClientIdInHash(window.location.hash);
  }, []);

  return (
    <>
      <BaseNav title="Time" nav={nav} navLinks={navLinks} />
      <Suspense fallback={<CpLoader />}>
        <TimeCardList contactId={contactId} parentTask={nav.subtask && nav.task} task={nav.subtask || nav.task} />
      </Suspense>
    </>
  );
};
